import * as React from "react";
import { ProductType } from "../../../../../Wrap/Constants/Enums/Domain/ProductType";
import { InstrumentSearchQuery } from "../../../../../Wrap/Models/Domains/Investment/InstrumentSearchQuery";
import { ISearchProps } from "../../Resource/Content";
import { AdvancedSearch } from "../Shared/AdvancedSearch";
import { OffPlatformSearch } from "./OffPlatformSearch";
import { useRef } from "react";

export const OffPlatform = (props: ISearchProps) => {
    const wrapperRef = useRef(null);

    const query: InstrumentSearchQuery = {
        ProductTypes: [ProductType.OffPlatform],
        ProductWrapperTypes: [props.type],
        ServiceProposition: props.accountServiceProposition,
    };
    if (props.canBeBought) {
        query["CanBeBought"] = true;
    }
    if (props.canBeSold) {
        query["CanBeSold"] = true;
    }

    if(props.CanBeTransferred) {
        query["CanBeTransferred"] = true;
    }

    return (
        <div>
            <AdvancedSearch
                query={query}
                hiercharyId={props.hiercharyId}
                index={props.index}
                cssWrapper="mb-24"
                showResult={wrapperRef}
                ProductTypes={ProductType.OffPlatform}
            >
                <OffPlatformSearch
                    hiercharyId={props.hiercharyId}
                    tableData={props.tableData}
                    type={props.type}
                    index={props.index}
                    accountServiceProposition={props.accountServiceProposition}
                    canBeBought={props.canBeBought}
                    canBeSold={props.canBeSold}
                    canBeTransferred={props.CanBeTransferred}
                    TailoredDrawdownAllowed={props.TailoredDrawdownAllowed}
                />
            </AdvancedSearch>
        </div>
    );
};
